import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import CustomerListResults from 'src/components/customer/CustomerListResults';
import CustomerToolbar from 'src/components/customer/CustomerToolbar';
import fullList from 'src/__mocks__/leads';
import { searchCustomer } from 'src/utils/helper';
import _ from 'lodash';

const CustomerList = () => {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState('');
  const [sortDirection, setSortDirection] = useState('desc');
  // const navigate = useNavigate();

  const onSort = () => {
    if (sortDirection === 'asc') {
      setSortDirection('desc');
      setCustomers([..._.orderBy(customers, ['firstName', 'lastName'], 'desc')]);
    } else {
      setSortDirection('asc');
      setCustomers([..._.orderBy(customers, ['firstName', 'lastName'], 'asc')]);
    }
  };

  useEffect(() => {
    setCustomers(fullList);
    onSort();
  }, []);

  useEffect(() => {
    setCustomers(searchCustomer(fullList, search));
  }, [search]);

  return (
    <>
      <Helmet>
        <title>Events | Lead Generation</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <CustomerToolbar onSearch={(text) => {
            setSearch(text);
          }}
          />
          <Box sx={{ pt: 3 }}>
            <CustomerListResults
              customers={customers}
              onItemClick={() => {
                // navigate('/app/events/1', { replace: false });
              }}
              sortDirection={sortDirection}
              onSort={onSort}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default CustomerList;
